import {
  Backdrop,
  Box,
  CircularProgress,
  Drawer,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { colors } from "../../theme/theme";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { createExerciseEvent } from "../../redux/actions/user.dispatcher";
import {
  Close,
  East,
  EmailOutlined,
  UploadOutlined,
  PersonOutline,
  Today,
  PhoneOutlined,
} from "@mui/icons-material";
import dayGridPlugin from "@fullcalendar/daygrid";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ErrorSnackbar } from "../Common/CustomSnackbar";
import { getSubscriptionOfUser } from "../../redux/actions/subscriptions.dispatcher";
import FullCalendar from "@fullcalendar/react";
import AddEventDrawer from "./AddEventDrawer";
import { SecondaryBtn } from "../Common/CustomBtn";
import axiosInstance from "../../utils/config/config";
import { useLocation } from "react-router-dom";

const ScheduleEvent = ({
  drawerState,
  setDrawerState,
  paidVideoData,
  setSuccess,
  creatorData,
  type,
  creatorId,
  userId,
}) => {
  const creator = type === "video" ? paidVideoData?.creator : creatorData;
  const { userData } = useSelector((state) => state.user);
  const location = useLocation();
  const visitingId = location.state?.visitingId || null;
  const [loading, setLoading] = useState(false);
  const [eventDrawerState, setEventDrawerState] = useState(false);
  const [uploadUrl, setUploadUrl] = useState(null);
  const [events, setEvents] = useState([]);
  const [eventFormData, setEventFormData] = useState({
    userId: userData.id,
    name: "",
    description: "",
    level: "",
    category: "",
    plan: "",
    duration: "",
    price: "",
    participants: "",
    deadline: null,
    startDateTime: null,
    endDate: null,
  });
  const dispatch = useDispatch();

  const [subscriptionDetails, setSubscriptionDetails] = useState(null);

  const handleAddEvent = () => {
    setEventDrawerState(true);
  };

  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const handleEventFormChange = (field, value) => {
    setEventFormData({ ...eventFormData, [field]: value });
  };

  const handleCreateEvent = async () => {
    setErrorState({ error: false, message: "" });
    if (!eventFormData.name || !eventFormData.description) {
      setErrorState({
        error: true,
        message: "Required fields cannot be empty",
      });
      return;
    }

    try {
      setLoading(true);

      const response = await createExerciseEvent({
        ...eventFormData,
        mediaURL: uploadUrl,
      });
      if (response) {
        setEventFormData({
          userId: userData.id,
          name: "",
          description: "",
          level: "",
          category: "",
          plan: "",
          duration: "",
          price: "",
          participants: "",
          deadline: null,
          startDateTime: null,
          endDate: null,
        });
        setDrawerState(false);
        setSuccess(true);
      }
    } catch (error) {
      console.log(error);
      setErrorState({ error: true, message: error.message });
    } finally {
      setLoading(false);
      setDrawerState(false);
    }
  };

  const fetchCreatorEvents = async () => {
    try {
      const eventsResponse = await axiosInstance.get(
        `/exerciseevent/getExerciseEventsByUser?userId=${
          visitingId ? visitingId : creatorId
        }`
      );

      const eventsData = eventsResponse.data.exerciseEvents.map((event) => ({
        id: event.id,
        title: event.name,
        start: event.startDateTime,
        end: event.endDate,
        extendedProps: {
          duration: event.duration,
          level: event.skillLevel,
          exercise: event.category,
          equipment: "Dumbbells",
          calories: "150 kcal",
          status: "Scheduled",
        },
      }));

      setEvents(eventsData); // Replace the events state
    } catch (err) {
      console.log(err);
    }
  };

  const renderEventContent = (eventInfo) => {
    const { duration, level, exercise, equipment, calories, status } =
      eventInfo.event.extendedProps;
    const title = eventInfo.event.title;
    return (
      <Box
        sx={{
          border: `1px solid ${status === "Scheduled" ? "red" : "#ccc"}`,
          borderRadius: "8px",
          padding: "8px",
          backgroundColor: "white",
          width: "100%",
          boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
          height: "300px",
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 600,
            backgroundColor: "red",
            color: "white",
            width: "fit-content",
            mb: 1,
            p: 0.5,
            borderRadius: "6px",
          }}
        >
          {duration}
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#000", fontWeight: 600 }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "#666" }}>
          {equipment}
        </Typography>
      </Box>
    );
  };

  const [headerToolbar, setHeaderToolbar] = useState(getHeaderToolbar());
  function getHeaderToolbar() {
    if (window.innerWidth < 768) {
      return {
        left: "prev,next",
        center: "title",
        right: "timeGridDay",
      };
    } else if (window.innerWidth < 1024) {
      return {
        left: "prev,next",
        center: "title",
        right:
          creatorId !== userData?.id
            ? "timeGridDay"
            : "timeGridDay addEventButton",
      };
    } else {
      return {
        left: "prev,next today",
        center: "title",
        right:
          creatorId !== userData?.id
            ? "timeGridDay,timeGridWeek,dayGridMonth"
            : "timeGridDay,timeGridWeek,dayGridMonth addEventButton",
      };
    }
  }

  const getSubscription = async () => {
    if (type === "creator" && drawerState) {
      const response = await getSubscriptionOfUser(creator?.creatorProfile?.id);

      setSubscriptionDetails(response);
    }
  };

  const mediumScreen = useMediaQuery("(max-width:960px)");

  useEffect(() => {
    getSubscription();
    if (userId || creatorId) {
      fetchCreatorEvents(userId || creatorId);
    }
  }, [drawerState, userId]);

  useEffect(() => {
    const handleResize = () => setHeaderToolbar(getHeaderToolbar());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Drawer
      anchor={"right"}
      open={drawerState}
      sx={{
        "& .MuiDrawer-paper": {
          width: "75%",
          border: "1px solid #000",
          backgroundColor: "#fff",
        },
      }}
      onClose={() => setDrawerState(false)}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* Snackbar */}
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 4,
            py: 2,
            borderBottom: "1px solid #000",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "20px", md: "23px", lg: "23px" }, // Responsive font sizes
              fontFamily: "Inter-SemiBold",
              color: colors.textColor,
            }}
          >
            Schedule Event
          </Typography>
          <Stack
            direction="row"
            alignItems={"center"}
            sx={{
              width: "50%",
              gap: 2,
              justifyContent: "flex-end",
            }}
          >
            <SecondaryBtn
              onClick={() => setDrawerState(false)}
              text="Close"
              Icon={Close}
              noMb
              noMt
              width="20%"
            />
            <SecondaryBtn
              onClick={handleCreateEvent}
              text="Create"
              Icon={East}
              noMb
              noMt
              width="30%"
              filled
            />
          </Stack>
        </Box>
        <Box
          sx={{
            px: 4,
            py: 2,
            borderBottom: "1px solid #000",
          }}
        >
          <FullCalendar
            plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
            initialView="timeGridDay"
            headerToolbar={headerToolbar}
            customButtons={{
              addEventButton: {
                text: "Add Event",
                click: handleAddEvent,
              },
            }}
            events={events}
            eventContent={renderEventContent}
            eventClick={() => drawerState(true)}
            slotMinTime="00:00:00"
            slotMaxTime="24:00:00"
            slotDuration="24:00:00"
            allDaySlot={false}
            eventOverlap={false}
          />
          <AddEventDrawer
            drawerState={eventDrawerState}
            setDrawerState={setEventDrawerState}
            paidVideoData={paidVideoData}
            setSuccess={setSuccess}
            type="video"
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default ScheduleEvent;
